export const SCENARIO_MESSAGE_TYPES = {
  CUSTOMER: 'CUSTOMER',
  SELLER: 'SELLER',
  STEP: 'STEP',
};
